import { ClientRouter } from '@/components/ClientRouter';

export default function Home() {
	return (
		<div className="h-full">
			<ClientRouter />
		</div>
	);
}
